"use strict";

var MultiSession = require('./MultiSession');

var MultiSessionData = require('./MultiSessionData');

var MultiSessionTempData = require('./MultiSessionTempData');

module.exports = {
  multiSession: new MultiSession(),
  MultiSession: MultiSession,
  MultiSessionData: MultiSessionData,
  MultiSessionTempData: MultiSessionTempData
};